import React, { FC } from 'react';

import { SvgIconProps } from '@mui/material/SvgIcon';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface ExpandIconProps extends SvgIconProps {
  /**
   * Determines which icon is shown.
   */
  open?: boolean;
}

export const ExpandIcon: FC<ExpandIconProps> = ({ open = false, ...props }) => {
  return open ? <ExpandLessIcon {...props} /> : <ExpandMoreIcon {...props} />;
};
